// extracted by mini-css-extract-plugin
export default {"container":"SideMenu_container__eYzCz","search":"SideMenu_search__NIQ4L","icon":"SideMenu_icon__EzHH+","menu_item":"SideMenu_menu_item__KS2Zz"};